// 请求接口地址 如果没有配置自动获取当前网址路径
import config from '@/config'
const serverSrc = process.env.NODE_ENV === 'development' ? config.serverSrcDev : `${location.origin}/`
const serverApiPic = process.env.NODE_ENV === 'development' ? config.serverSrcDev +
                    'adminapi/uploadsPic' : `${location.origin}/` +
                    'adminapi/uploadsPic'

const Setting = {
  serverSrc,
  serverApiPic
}

export default Setting
